export default [
  {
    path: '/defines/workers',
    name: 'Workers',
    component: () => import('@/views/Defines/Workers/Index.vue'),
    meta: {
      pageTitle: 'Servis Personeli',
      breadcrumb: [
        {
          text: 'Listele',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES',
      action: 'read',
    },
  },
  {
    path: '/defines/workers/add',
    name: 'WorkerAdd',
    component: () => import('@/views/Defines/Workers/Add.vue'),
    meta: {
      pageTitle: 'Servis Personeli',
      breadcrumb: [
        {
          text: 'Listele',
          to: '/defines/workers',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES',
      action: 'read',
    },
  },
  {
    path: '/defines/workers/edit/:id',
    name: 'WorkerEdit',
    component: () => import('@/views/Defines/Workers/Edit.vue'),
    meta: {
      pageTitle: 'Servis Personeli',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/defines/workers',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES',
      action: 'read',
    },
  },
]
